import { css } from '@emotion/react';
import React from 'react';

import Card from '@/core/components/layout/Card.component';
import { useTranslation } from '@/i18n';
import { Markdown } from '@/markdown';
import { Spacer } from '@/ui/spacing';
import { useTheme } from '@/ui/theme';
import { BodyCopy, Heading } from '@/ui/typography';

interface ThirdPartyPaymentDownloadCardProps {
  destinationEmailAddress: string;
}

export const ThirdPartyPaymentDownloadCard = (
  props: ThirdPartyPaymentDownloadCardProps
) => {
  const { t } = useTranslation('payment');
  const {
    forms,
    componentProperties: { confirmation },
  } = useTheme();
  return (
    <Card>
      <Heading
        style="heading5"
        as="h5"
        css={css({
          ...forms.heading,
          ...confirmation?.thirdPartyPaymentDownloadCard?.title,
          ['@media all and (max-width: 730px)']: forms.heading?.mobile,
        })}
      >
        {t('thirdPartyPayment.title')}
      </Heading>
      <Spacer s="xs" />
      <div css={css({ maxWidth: '700px' })}>
        <BodyCopy
          css={confirmation?.thirdPartyPaymentDownloadCard?.description}
        >
          <Markdown
            source={t('thirdPartyPayment.description1', {
              email: props.destinationEmailAddress,
            })}
          />
        </BodyCopy>
        <Spacer s="xs" />
        <BodyCopy
          css={confirmation?.thirdPartyPaymentDownloadCard?.description}
        >
          {t('thirdPartyPayment.description2')}
        </BodyCopy>
      </div>
    </Card>
  );
};
